import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// Asset Manager
import BaseMixer from "../../BaseMixer";
import { IAssetPropertyDTO } from "@/store/models/asset/assetProperty";
import _ from "lodash";
import { AssetMasterModule } from "@/store/modules/asset.module";
let AssetTypePropertyComponent = /** @class */ (() => {
    var _a;
    let AssetTypePropertyComponent = class AssetTypePropertyComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.filteredControlTypes = [];
        }
        get controlTypes() {
            this.filteredControlTypes = [];
            for (var i = 0; i < Object.keys(this.assetControlTypes).length; i++) {
                if (this.assetTypeProperty.controlDataListId == this.assetControlTypes[i].masterId) {
                    this.filteredControlTypes.push(this.assetControlTypes[i]);
                }
            }
            return this.filteredControlTypes;
        }
        get getAssetPropertiesValues() {
            return AssetMasterModule.getAssetPropertiesValues;
        }
        sortArrays(arrays) {
            return _.orderBy(arrays, "description", "asc");
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IAssetPropertyDTO !== "undefined" && IAssetPropertyDTO) === "function" ? _a : Object)
    ], AssetTypePropertyComponent.prototype, "assetTypeProperty", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], AssetTypePropertyComponent.prototype, "assetControlTypes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AssetTypePropertyComponent.prototype, "canEditAssetTypeProperty", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AssetTypePropertyComponent.prototype, "showMandatory", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AssetTypePropertyComponent.prototype, "showEditAsset", void 0);
    AssetTypePropertyComponent = __decorate([
        Component({
            name: "AssetTypePropertyComponent",
        })
    ], AssetTypePropertyComponent);
    return AssetTypePropertyComponent;
})();
export default AssetTypePropertyComponent;
